var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("../../assets/class_logo.png")}}),_c('div',[_c('div',{staticClass:"climate-message__text--primary"},[_vm._v("You are currently blocked")]),_c('div',{staticClass:"climate-message__text--secondary"},[_vm._v("Please wait the teacher to unblock you")]),_c('div',{staticClass:"opt_area"})])])
}]

export { render, staticRenderFns }